import styled from 'styled-components';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@mui/material';

export const Container = styled.div``;

export const AccordionHistory = styled(Accordion)`
  &&& {
    background: ${({ theme }) => theme.white};
    padding: 0.3rem 0;
    margin: 0;

    /* When is Expanded */
    &.MuiAccordion-root.Mui-expanded {
      margin: 0;
    }

    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.pantone2727C};
    }
  }
`;

export const AccordionHistoryWithoutDetail = styled.div`
  background: ${({ theme }) => theme.white};
  padding: 10px 0px 10px 20px;
  margin: 0px;
  border-bottom: 1px solid #dcdcdc;

  > span {
    color: ${({ theme }) => theme.pantone2726C};
    font-weight: bold;
  }
`;

export const AccordionSummaryHistory = styled(AccordionSummary)`
  &&& {
    background: ${({ theme }) => theme.white};
  }
`;
export const AccordionTitle = styled.p`
  &&& {
    color: #000 !important;
    margin: 0;

    > span {
      color: ${({ theme }) => theme.pantone2726C};
      font-weight: bold;
    }
  }
`;

export const AccordionDetailsHistory = styled(AccordionDetails)`
  &&& {
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.white};
    gap: 1rem;
    padding: 0.4rem 2rem 0;
  }
`;
